import BaseList from '@editorjs/list'
import { IconListBulleted, IconListNumbered } from '@codexteam/icons'

export class List extends BaseList {
    static get toolbox() {
        return [
            {
                icon: IconListBulleted,
                title: 'Unordered',
                data: {
                    style: 'unordered',
                },
            },
            {
                icon: IconListNumbered,
                title: 'Ordered',
                data: {
                    style: 'ordered',
                },
            },
        ]
    }
}
